/**
 * Verse deck.
 *
 * Text is the World English Bible (British Edition) — a public-domain
 * translation, so it ships with the app without licensing concerns.
 *
 * Each verse:
 *   id        stable slug, used as the localStorage key for bookmarks/progress
 *   book      must match a `book` in books.js so learning paths line up
 *   ref       human-readable reference
 *   text      the verse itself
 *   testament 'old' | 'new'
 *   theme     used for filtering, colour accents and quiz grouping
 */

export const VERSES = [
  // ── Old Testament ────────────────────────────────────────────────────────
  {
    id: 'gen-1-1',
    book: 'Genesis',
    ref: 'Genesis 1:1',
    text: 'In the beginning, God created the heavens and the earth.',
    testament: 'old',
    theme: 'Creation',
  },
  {
    id: 'gen-1-27',
    book: 'Genesis',
    ref: 'Genesis 1:27',
    text: 'God created man in his own image. In God’s image he created him; male and female he created them.',
    testament: 'old',
    theme: 'Creation',
  },
  {
    id: 'gen-2-24',
    book: 'Genesis',
    ref: 'Genesis 2:24',
    text: 'Therefore a man will leave his father and his mother, and will join with his wife, and they will be one flesh.',
    testament: 'old',
    theme: 'Relationships',
  },
  {
    id: 'gen-3-15',
    book: 'Genesis',
    ref: 'Genesis 3:15',
    text: 'I will put hostility between you and the woman, and between your offspring and her offspring. He will bruise your head, and you will bruise his heel.',
    testament: 'old',
    theme: 'Promise',
  },
  {
    id: 'gen-9-13',
    book: 'Genesis',
    ref: 'Genesis 9:13',
    text: 'I set my rainbow in the cloud, and it will be a sign of a covenant between me and the earth.',
    testament: 'old',
    theme: 'Covenant',
  },
  {
    id: 'gen-11-4',
    book: 'Genesis',
    ref: 'Genesis 11:4',
    text: 'Come, let’s build ourselves a city, and a tower whose top reaches to the sky, and let’s make a name for ourselves.',
    testament: 'old',
    theme: 'Pride',
  },
  {
    id: 'gen-12-2',
    book: 'Genesis',
    ref: 'Genesis 12:2',
    text: 'I will make of you a great nation. I will bless you and make your name great. You will be a blessing.',
    testament: 'old',
    theme: 'Promise',
  },
  {
    id: 'gen-22-14',
    book: 'Genesis',
    ref: 'Genesis 22:14',
    text: 'Abraham called the name of that place “The LORD Will Provide”. As it is said to this day, “On the LORD’s mountain, it will be provided.”',
    testament: 'old',
    theme: 'Providence',
  },
  {
    id: 'gen-32-28',
    book: 'Genesis',
    ref: 'Genesis 32:28',
    text: 'Your name will no longer be called Jacob, but Israel; for you have fought with God and with men, and have prevailed.',
    testament: 'old',
    theme: 'Perseverance',
  },
  {
    id: 'gen-50-20',
    book: 'Genesis',
    ref: 'Genesis 50:20',
    text: 'As for you, you meant evil against me, but God meant it for good, to save many people alive, as is happening today.',
    testament: 'old',
    theme: 'Providence',
  },
  {
    id: 'exo-3-14',
    book: 'Exodus',
    ref: 'Exodus 3:14',
    text: 'God said to Moses, “I AM WHO I AM,” and he said, “You shall tell the children of Israel this: ‘I AM has sent me to you.’”',
    testament: 'old',
    theme: 'God’s Character',
  },
  {
    id: 'exo-14-14',
    book: 'Exodus',
    ref: 'Exodus 14:14',
    text: 'The LORD will fight for you, and you shall be still.',
    testament: 'old',
    theme: 'Trust',
  },
  {
    id: 'exo-20-3',
    book: 'Exodus',
    ref: 'Exodus 20:3',
    text: 'You shall have no other gods before me.',
    testament: 'old',
    theme: 'Obedience',
  },
  {
    id: 'lev-19-18',
    book: 'Leviticus',
    ref: 'Leviticus 19:18',
    text: 'You shall not take vengeance, nor bear any grudge against the children of your people; but you shall love your neighbour as yourself.',
    testament: 'old',
    theme: 'Love',
  },
  {
    id: 'num-6-24',
    book: 'Numbers',
    ref: 'Numbers 6:24–26',
    text: 'The LORD bless you, and keep you. The LORD make his face to shine on you, and be gracious to you. The LORD lift up his face towards you, and give you peace.',
    testament: 'old',
    theme: 'Blessing',
  },
  {
    id: 'deu-6-5',
    book: 'Deuteronomy',
    ref: 'Deuteronomy 6:5',
    text: 'You shall love the LORD your God with all your heart, with all your soul, and with all your might.',
    testament: 'old',
    theme: 'Love',
  },
  {
    id: 'deu-31-6',
    book: 'Deuteronomy',
    ref: 'Deuteronomy 31:6',
    text: 'Be strong and courageous. Don’t be afraid or scared of them; for the LORD your God himself is who goes with you. He will not fail you nor forsake you.',
    testament: 'old',
    theme: 'Courage',
  },
  {
    id: 'jos-1-9',
    book: 'Joshua',
    ref: 'Joshua 1:9',
    text: 'Haven’t I commanded you? Be strong and courageous. Don’t be afraid. Don’t be dismayed, for the LORD your God is with you wherever you go.',
    testament: 'old',
    theme: 'Courage',
  },
  {
    id: 'jos-24-15',
    book: 'Joshua',
    ref: 'Joshua 24:15',
    text: 'Choose today whom you will serve … but as for me and my house, we will serve the LORD.',
    testament: 'old',
    theme: 'Obedience',
  },
  {
    id: 'rut-1-16',
    book: 'Ruth',
    ref: 'Ruth 1:16',
    text: 'Where you go, I will go; and where you stay, I will stay. Your people will be my people, and your God my God.',
    testament: 'old',
    theme: 'Faithfulness',
  },
  {
    id: '1sa-16-7',
    book: '1 Samuel',
    ref: '1 Samuel 16:7',
    text: 'For man sees the outward appearance, but the LORD looks at the heart.',
    testament: 'old',
    theme: 'God’s Character',
  },
  {
    id: '1ki-3-9',
    book: '1 Kings',
    ref: '1 Kings 3:9',
    text: 'Give your servant therefore an understanding heart to judge your people, that I may discern between good and evil.',
    testament: 'old',
    theme: 'Wisdom',
  },
  {
    id: '2ch-7-14',
    book: '2 Chronicles',
    ref: '2 Chronicles 7:14',
    text: 'If my people, who are called by my name, will humble themselves, pray, seek my face, and turn from their wicked ways, then I will hear from heaven, will forgive their sin, and will heal their land.',
    testament: 'old',
    theme: 'Repentance',
  },
  {
    id: 'job-19-25',
    book: 'Job',
    ref: 'Job 19:25',
    text: 'But as for me, I know that my Redeemer lives. In the end, he will stand upon the earth.',
    testament: 'old',
    theme: 'Hope',
  },
  {
    id: 'psa-1-1',
    book: 'Psalms',
    ref: 'Psalm 1:1–2',
    text: 'Blessed is the man who doesn’t walk in the counsel of the wicked … but his delight is in the LORD’s law. On his law he meditates day and night.',
    testament: 'old',
    theme: 'Scripture',
  },
  {
    id: 'psa-23-1',
    book: 'Psalms',
    ref: 'Psalm 23:1',
    text: 'The LORD is my shepherd; I shall lack nothing.',
    testament: 'old',
    theme: 'Trust',
  },
  {
    id: 'psa-23-4',
    book: 'Psalms',
    ref: 'Psalm 23:4',
    text: 'Even though I walk through the valley of the shadow of death, I will fear no evil, for you are with me. Your rod and your staff, they comfort me.',
    testament: 'old',
    theme: 'Comfort',
  },
  {
    id: 'psa-27-1',
    book: 'Psalms',
    ref: 'Psalm 27:1',
    text: 'The LORD is my light and my salvation. Whom shall I fear? The LORD is the strength of my life. Of whom shall I be afraid?',
    testament: 'old',
    theme: 'Courage',
  },
  {
    id: 'psa-34-18',
    book: 'Psalms',
    ref: 'Psalm 34:18',
    text: 'The LORD is near to those who have a broken heart, and saves those who have a crushed spirit.',
    testament: 'old',
    theme: 'Comfort',
  },
  {
    id: 'psa-46-1',
    book: 'Psalms',
    ref: 'Psalm 46:1',
    text: 'God is our refuge and strength, a very present help in trouble.',
    testament: 'old',
    theme: 'Comfort',
  },
  {
    id: 'psa-51-10',
    book: 'Psalms',
    ref: 'Psalm 51:10',
    text: 'Create in me a clean heart, O God. Renew a right spirit within me.',
    testament: 'old',
    theme: 'Repentance',
  },
  {
    id: 'psa-91-1',
    book: 'Psalms',
    ref: 'Psalm 91:1',
    text: 'He who dwells in the secret place of the Most High will rest in the shadow of the Almighty.',
    testament: 'old',
    theme: 'Trust',
  },
  {
    id: 'psa-119-105',
    book: 'Psalms',
    ref: 'Psalm 119:105',
    text: 'Your word is a lamp to my feet, and a light for my path.',
    testament: 'old',
    theme: 'Scripture',
  },
  {
    id: 'psa-121-1',
    book: 'Psalms',
    ref: 'Psalm 121:1–2',
    text: 'I will lift up my eyes to the hills. Where does my help come from? My help comes from the LORD, who made heaven and earth.',
    testament: 'old',
    theme: 'Trust',
  },
  {
    id: 'psa-139-14',
    book: 'Psalms',
    ref: 'Psalm 139:14',
    text: 'I will give thanks to you, for I am fearfully and wonderfully made. Your works are wonderful. My soul knows that very well.',
    testament: 'old',
    theme: 'Identity',
  },
  {
    id: 'pro-3-5',
    book: 'Proverbs',
    ref: 'Proverbs 3:5–6',
    text: 'Trust in the LORD with all your heart, and don’t lean on your own understanding. In all your ways acknowledge him, and he will make your paths straight.',
    testament: 'old',
    theme: 'Wisdom',
  },
  {
    id: 'pro-16-9',
    book: 'Proverbs',
    ref: 'Proverbs 16:9',
    text: 'A man’s heart plans his course, but the LORD directs his steps.',
    testament: 'old',
    theme: 'Providence',
  },
  {
    id: 'pro-22-6',
    book: 'Proverbs',
    ref: 'Proverbs 22:6',
    text: 'Train up a child in the way he should go, and when he is old he will not depart from it.',
    testament: 'old',
    theme: 'Wisdom',
  },
  {
    id: 'ecc-3-1',
    book: 'Ecclesiastes',
    ref: 'Ecclesiastes 3:1',
    text: 'For everything there is a season, and a time for every purpose under heaven.',
    testament: 'old',
    theme: 'Wisdom',
  },
  {
    id: 'isa-9-6',
    book: 'Isaiah',
    ref: 'Isaiah 9:6',
    text: 'For a child is born to us. A son is given to us; and the government will be on his shoulders. His name will be called Wonderful Counsellor, Mighty God, Everlasting Father, Prince of Peace.',
    testament: 'old',
    theme: 'Prophecy',
  },
  {
    id: 'isa-40-31',
    book: 'Isaiah',
    ref: 'Isaiah 40:31',
    text: 'But those who wait for the LORD will renew their strength. They will mount up with wings like eagles. They will run, and not be weary. They will walk, and not faint.',
    testament: 'old',
    theme: 'Hope',
  },
  {
    id: 'isa-41-10',
    book: 'Isaiah',
    ref: 'Isaiah 41:10',
    text: 'Don’t you be afraid, for I am with you. Don’t be dismayed, for I am your God. I will strengthen you. Yes, I will help you. Yes, I will uphold you with the right hand of my righteousness.',
    testament: 'old',
    theme: 'Courage',
  },
  {
    id: 'isa-53-5',
    book: 'Isaiah',
    ref: 'Isaiah 53:5',
    text: 'But he was pierced for our transgressions. He was crushed for our iniquities. The punishment that brought our peace was on him; and by his wounds we are healed.',
    testament: 'old',
    theme: 'Prophecy',
  },
  {
    id: 'jer-29-11',
    book: 'Jeremiah',
    ref: 'Jeremiah 29:11',
    text: 'For I know the thoughts that I think towards you, says the LORD, thoughts of peace, and not of evil, to give you hope and a future.',
    testament: 'old',
    theme: 'Hope',
  },
  {
    id: 'lam-3-22',
    book: 'Lamentations',
    ref: 'Lamentations 3:22–23',
    text: 'It is because of the LORD’s loving kindnesses that we are not consumed, because his compassion doesn’t fail. They are new every morning. Great is your faithfulness.',
    testament: 'old',
    theme: 'Faithfulness',
  },
  {
    id: 'eze-36-26',
    book: 'Ezekiel',
    ref: 'Ezekiel 36:26',
    text: 'I will also give you a new heart, and I will put a new spirit within you. I will take away the stony heart out of your flesh, and I will give you a heart of flesh.',
    testament: 'old',
    theme: 'Transformation',
  },
  {
    id: 'dan-3-17',
    book: 'Daniel',
    ref: 'Daniel 3:17–18',
    text: 'Our God whom we serve is able to deliver us from the burning fiery furnace … But if not, let it be known to you, O king, that we will not serve your gods.',
    testament: 'old',
    theme: 'Faithfulness',
  },
  {
    id: 'mic-6-8',
    book: 'Micah',
    ref: 'Micah 6:8',
    text: 'He has shown you, O man, what is good. What does the LORD require of you, but to act justly, to love mercy, and to walk humbly with your God?',
    testament: 'old',
    theme: 'Obedience',
  },
  {
    id: 'zep-3-17',
    book: 'Zephaniah',
    ref: 'Zephaniah 3:17',
    text: 'The LORD your God is amongst you, a mighty one who will save. He will rejoice over you with joy. He will calm you in his love. He will rejoice over you with singing.',
    testament: 'old',
    theme: 'Love',
  },
  {
    id: 'mal-3-10',
    book: 'Malachi',
    ref: 'Malachi 3:10',
    text: 'Bring the whole tithe into the storehouse … and test me now in this, says the LORD of Armies, if I will not open you the windows of heaven, and pour you out a blessing.',
    testament: 'old',
    theme: 'Obedience',
  },
  {
    id: 'mal-4-2',
    book: 'Malachi',
    ref: 'Malachi 4:2',
    text: 'But to you who fear my name, the sun of righteousness will arise with healing in its wings.',
    testament: 'old',
    theme: 'Hope',
  },

  // ── New Testament ────────────────────────────────────────────────────────
  {
    id: 'mat-5-14',
    book: 'Matthew',
    ref: 'Matthew 5:14',
    text: 'You are the light of the world. A city located on a hill can’t be hidden.',
    testament: 'new',
    theme: 'Discipleship',
  },
  {
    id: 'mat-6-33',
    book: 'Matthew',
    ref: 'Matthew 6:33',
    text: 'But seek first God’s Kingdom and his righteousness; and all these things will be given to you as well.',
    testament: 'new',
    theme: 'Discipleship',
  },
  {
    id: 'mat-11-28',
    book: 'Matthew',
    ref: 'Matthew 11:28',
    text: 'Come to me, all you who labour and are heavily burdened, and I will give you rest.',
    testament: 'new',
    theme: 'Comfort',
  },
  {
    id: 'mat-22-37',
    book: 'Matthew',
    ref: 'Matthew 22:37–39',
    text: 'You shall love the Lord your God with all your heart, with all your soul, and with all your mind. This is the first and great commandment. A second likewise is this: You shall love your neighbour as yourself.',
    testament: 'new',
    theme: 'Love',
  },
  {
    id: 'mat-28-19',
    book: 'Matthew',
    ref: 'Matthew 28:19–20',
    text: 'Go and make disciples of all nations, baptising them in the name of the Father and of the Son and of the Holy Spirit … Behold, I am with you always, even to the end of the age.',
    testament: 'new',
    theme: 'Mission',
  },
  {
    id: 'mar-10-45',
    book: 'Mark',
    ref: 'Mark 10:45',
    text: 'For the Son of Man also came not to be served, but to serve, and to give his life as a ransom for many.',
    testament: 'new',
    theme: 'Jesus',
  },
  {
    id: 'mar-16-15',
    book: 'Mark',
    ref: 'Mark 16:15',
    text: 'Go into all the world, and preach the Good News to the whole creation.',
    testament: 'new',
    theme: 'Mission',
  },
  {
    id: 'luk-1-37',
    book: 'Luke',
    ref: 'Luke 1:37',
    text: 'For nothing spoken by God is impossible.',
    testament: 'new',
    theme: 'Faith',
  },
  {
    id: 'luk-6-31',
    book: 'Luke',
    ref: 'Luke 6:31',
    text: 'As you would like people to do to you, do exactly so to them.',
    testament: 'new',
    theme: 'Love',
  },
  {
    id: 'luk-24-6',
    book: 'Luke',
    ref: 'Luke 24:6',
    text: 'He isn’t here, but is risen. Remember what he told you when he was still in Galilee.',
    testament: 'new',
    theme: 'Resurrection',
  },
  {
    id: 'joh-1-1',
    book: 'John',
    ref: 'John 1:1',
    text: 'In the beginning was the Word, and the Word was with God, and the Word was God.',
    testament: 'new',
    theme: 'Jesus',
  },
  {
    id: 'joh-3-16',
    book: 'John',
    ref: 'John 3:16',
    text: 'For God so loved the world, that he gave his one and only Son, that whoever believes in him should not perish, but have eternal life.',
    testament: 'new',
    theme: 'Salvation',
  },
  {
    id: 'joh-8-12',
    book: 'John',
    ref: 'John 8:12',
    text: 'I am the light of the world. He who follows me will not walk in the darkness, but will have the light of life.',
    testament: 'new',
    theme: 'Jesus',
  },
  {
    id: 'joh-14-6',
    book: 'John',
    ref: 'John 14:6',
    text: 'I am the way, the truth, and the life. No one comes to the Father, except through me.',
    testament: 'new',
    theme: 'Jesus',
  },
  {
    id: 'joh-15-5',
    book: 'John',
    ref: 'John 15:5',
    text: 'I am the vine. You are the branches. He who remains in me and I in him bears much fruit, for apart from me you can do nothing.',
    testament: 'new',
    theme: 'Discipleship',
  },
  {
    id: 'act-1-8',
    book: 'Acts',
    ref: 'Acts 1:8',
    text: 'But you will receive power when the Holy Spirit has come upon you. You will be witnesses to me in Jerusalem, in all Judea and Samaria, and to the uttermost parts of the earth.',
    testament: 'new',
    theme: 'Mission',
  },
  {
    id: 'act-4-12',
    book: 'Acts',
    ref: 'Acts 4:12',
    text: 'There is salvation in no one else, for there is no other name under heaven that is given amongst men, by which we must be saved!',
    testament: 'new',
    theme: 'Salvation',
  },
  {
    id: 'rom-3-23',
    book: 'Romans',
    ref: 'Romans 3:23',
    text: 'For all have sinned, and fall short of the glory of God.',
    testament: 'new',
    theme: 'Salvation',
  },
  {
    id: 'rom-5-8',
    book: 'Romans',
    ref: 'Romans 5:8',
    text: 'But God commends his own love towards us, in that while we were yet sinners, Christ died for us.',
    testament: 'new',
    theme: 'Love',
  },
  {
    id: 'rom-6-23',
    book: 'Romans',
    ref: 'Romans 6:23',
    text: 'For the wages of sin is death, but the free gift of God is eternal life in Christ Jesus our Lord.',
    testament: 'new',
    theme: 'Salvation',
  },
  {
    id: 'rom-8-28',
    book: 'Romans',
    ref: 'Romans 8:28',
    text: 'We know that all things work together for good for those who love God, for those who are called according to his purpose.',
    testament: 'new',
    theme: 'Providence',
  },
  {
    id: 'rom-8-38',
    book: 'Romans',
    ref: 'Romans 8:38–39',
    text: 'For I am persuaded that neither death, nor life … nor any other created thing will be able to separate us from God’s love which is in Christ Jesus our Lord.',
    testament: 'new',
    theme: 'Love',
  },
  {
    id: 'rom-12-2',
    book: 'Romans',
    ref: 'Romans 12:2',
    text: 'Don’t be conformed to this world, but be transformed by the renewing of your mind, so that you may prove what is the good, well-pleasing, and perfect will of God.',
    testament: 'new',
    theme: 'Transformation',
  },
  {
    id: '1co-13-4',
    book: '1 Corinthians',
    ref: '1 Corinthians 13:4–5',
    text: 'Love is patient and is kind. Love doesn’t envy. Love doesn’t brag, is not proud, doesn’t behave itself inappropriately, doesn’t seek its own way, is not provoked, takes no account of evil.',
    testament: 'new',
    theme: 'Love',
  },
  {
    id: '2co-5-17',
    book: '2 Corinthians',
    ref: '2 Corinthians 5:17',
    text: 'Therefore if anyone is in Christ, he is a new creation. The old things have passed away. Behold, all things have become new.',
    testament: 'new',
    theme: 'Transformation',
  },
  {
    id: '2co-12-9',
    book: '2 Corinthians',
    ref: '2 Corinthians 12:9',
    text: 'My grace is sufficient for you, for my power is made perfect in weakness.',
    testament: 'new',
    theme: 'Grace',
  },
  {
    id: 'gal-5-22',
    book: 'Galatians',
    ref: 'Galatians 5:22–23',
    text: 'But the fruit of the Spirit is love, joy, peace, patience, kindness, goodness, faith, gentleness, and self-control. Against such things there is no law.',
    testament: 'new',
    theme: 'Transformation',
  },
  {
    id: 'eph-2-8',
    book: 'Ephesians',
    ref: 'Ephesians 2:8–9',
    text: 'For by grace you have been saved through faith, and that not of yourselves; it is the gift of God, not of works, that no one would boast.',
    testament: 'new',
    theme: 'Grace',
  },
  {
    id: 'eph-6-11',
    book: 'Ephesians',
    ref: 'Ephesians 6:11',
    text: 'Put on the whole armour of God, that you may be able to stand against the wiles of the devil.',
    testament: 'new',
    theme: 'Perseverance',
  },
  {
    id: 'phi-4-6',
    book: 'Philippians',
    ref: 'Philippians 4:6–7',
    text: 'In nothing be anxious, but in everything, by prayer and petition with thanksgiving, let your requests be made known to God. And the peace of God, which surpasses all understanding, will guard your hearts and your thoughts in Christ Jesus.',
    testament: 'new',
    theme: 'Prayer',
  },
  {
    id: 'phi-4-13',
    book: 'Philippians',
    ref: 'Philippians 4:13',
    text: 'I can do all things through Christ, who strengthens me.',
    testament: 'new',
    theme: 'Perseverance',
  },
  {
    id: 'col-3-23',
    book: 'Colossians',
    ref: 'Colossians 3:23',
    text: 'And whatever you do, work heartily, as for the Lord, and not for men.',
    testament: 'new',
    theme: 'Discipleship',
  },
  {
    id: '1th-5-16',
    book: '1 Thessalonians',
    ref: '1 Thessalonians 5:16–18',
    text: 'Always rejoice. Pray without ceasing. In everything give thanks, for this is the will of God in Christ Jesus towards you.',
    testament: 'new',
    theme: 'Prayer',
  },
  {
    id: '2ti-1-7',
    book: '2 Timothy',
    ref: '2 Timothy 1:7',
    text: 'For God didn’t give us a spirit of fear, but of power, love, and self-control.',
    testament: 'new',
    theme: 'Courage',
  },
  {
    id: '2ti-3-16',
    book: '2 Timothy',
    ref: '2 Timothy 3:16–17',
    text: 'Every Scripture is God-breathed and profitable for teaching, for reproof, for correction, and for instruction in righteousness, that each person who belongs to God may be complete, thoroughly equipped for every good work.',
    testament: 'new',
    theme: 'Scripture',
  },
  {
    id: 'heb-11-1',
    book: 'Hebrews',
    ref: 'Hebrews 11:1',
    text: 'Now faith is assurance of things hoped for, proof of things not seen.',
    testament: 'new',
    theme: 'Faith',
  },
  {
    id: 'heb-12-1',
    book: 'Hebrews',
    ref: 'Hebrews 12:1',
    text: 'Let’s lay aside every weight and the sin which so easily entangles us, and let’s run with perseverance the race that is set before us.',
    testament: 'new',
    theme: 'Perseverance',
  },
  {
    id: 'heb-13-8',
    book: 'Hebrews',
    ref: 'Hebrews 13:8',
    text: 'Jesus Christ is the same yesterday, today, and forever.',
    testament: 'new',
    theme: 'Jesus',
  },
  {
    id: 'jam-1-2',
    book: 'James',
    ref: 'James 1:2–3',
    text: 'Count it all joy, my brothers, when you fall into various temptations, knowing that the testing of your faith produces endurance.',
    testament: 'new',
    theme: 'Perseverance',
  },
  {
    id: 'jam-1-22',
    book: 'James',
    ref: 'James 1:22',
    text: 'But be doers of the word, and not only hearers, deluding your own selves.',
    testament: 'new',
    theme: 'Obedience',
  },
  {
    id: '1pe-5-7',
    book: '1 Peter',
    ref: '1 Peter 5:7',
    text: 'Casting all your worries on him, because he cares for you.',
    testament: 'new',
    theme: 'Trust',
  },
  {
    id: '1jo-1-9',
    book: '1 John',
    ref: '1 John 1:9',
    text: 'If we confess our sins, he is faithful and righteous to forgive us the sins, and to cleanse us from all unrighteousness.',
    testament: 'new',
    theme: 'Repentance',
  },
  {
    id: '1jo-4-19',
    book: '1 John',
    ref: '1 John 4:19',
    text: 'We love him, because he first loved us.',
    testament: 'new',
    theme: 'Love',
  },
  {
    id: 'rev-3-20',
    book: 'Revelation',
    ref: 'Revelation 3:20',
    text: 'Behold, I stand at the door and knock. If anyone hears my voice and opens the door, then I will come in to him and will dine with him, and he with me.',
    testament: 'new',
    theme: 'Jesus',
  },
  {
    id: 'rev-21-4',
    book: 'Revelation',
    ref: 'Revelation 21:4',
    text: 'He will wipe away every tear from their eyes. Death will be no more; neither will there be mourning, nor crying, nor pain any more.',
    testament: 'new',
    theme: 'Hope',
  },
];

export const VERSES_BY_ID = Object.fromEntries(VERSES.map((v) => [v.id, v]));

export const THEMES = [...new Set(VERSES.map((v) => v.theme))].sort();

/** Verses for a given book, in deck order. */
export function versesForBook(book) {
  return VERSES.filter((v) => v.book === book);
}
